<template>
  <div>
    <v-dialog v-model="isOpen">
      <v-card class="rounded-xl">
        <v-card-title>
          <template v-if="decryptMemId()">Switch</template
          ><template v-else>Select</template> Member
        </v-card-title>
        <v-card-text>
          <v-list>
            <template v-for="(user, uIndex) in usersList">
              <v-list-item class="px-0" :key="uIndex" @click="changeUser(user)">
                <v-list-item-avatar size="48">
                  <img v-if="user.storedUrl" :src="siteName + user.storedUrl" />
                  <v-icon v-else>mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ user.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    user.mobileNumber
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon v-if="user.id == currentUserId">
                    mdi-check-circle green--text
                  </v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider
                :key="uIndex"
                v-if="uIndex != usersList.length - 1"
                inset
              ></v-divider>
            </template>
            <v-btn class="mt-5" dark color="#e01c24" block @click="getLogOutConfirmation">
              Logout<v-icon right>mdi-exit-to-app</v-icon>
            </v-btn>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmBox ref="confirmBoxRef" @confirm="confirmed"/>
  </div>
</template>
<script>
import { callApi } from "@/api/others";
import { returnURL } from "@/api/login.js";
export default {
  components:{
    ConfirmBox: () => import("@/components/tools/toolbox/ConfirmBox.vue"),
  },
  data: () => ({
    siteName: returnURL(),
    isOpen: false,
    usersList: [],
    currentUserId: "",
  }),
  props: {
    userModel: Object,
  },
  async mounted() {
    await this.getAllUsers();
    this.getCurrentUser();
    this.currentUserId = this.decryptMemId();
  },
  methods: {
    open() {
      this.isOpen = true;
    },
    getAllUsers() {
      return new Promise((resolve) => {
        this.$emit("loadingChange", true);
        let url = `/api/wesupport/Member/GetOtherMembersWithSameMobile`;
        callApi(url, "get", "")
          .then((res) => {
            this.usersList = res.data.data;
            if(this.usersList.length == 1){
              this.changeUser(this.usersList[0],!this.decryptMemId())
              // this.encryptMemId(this.usersList[0].id);
              // this.currentUserId = this.usersList[0].id;
              // this.$route.go(this.$route.name);
            }
            this.$emit("loadingChange", false);
            resolve()
          })
          .catch((err) => {});
      });
    },
    getCurrentUser() {
      if (!this.decryptMemId()) {
        this.open();
      }
    },
    changeUser(user,reload=true) {
      this.$emit("loadingChange", true);
      this.encryptMemId(user.id);
      this.currentUserId = user.id;
      if(reload){
        setTimeout(() => {
          // location.reload();
          this.$emit("changedUser",true)
        }, 500);
      }
    },
    getLogOutConfirmation(){
      this.$refs.confirmBoxRef.open();
    },
    confirmed(confirm){
      if(confirm){
        this.logOut();  
      }else{
        this.$refs.confirmBoxRef.close();
      }
    },
    logOut() {
      localStorage.clear();
      location.reload();
    },
  },
};
</script>